require("./components/bootstrap");
import mixin from "./components/mixin.js";
import Axios from "axios";
import {
    isInt
} from "@fullcalendar/core";
var cartDetailVue = new Vue({
    el: ".shopping-cart-main-area",
    mixins: [mixin],
    data: {
        lang: document.getElementsByTagName("html")[0].getAttribute("lang"),
        message: "",
        cartList: typeof cartList !== "undefined" ? cartList : {},
        remark: cartRemark ? cartRemark : '',
        showRemark: cartRemark ? true : false,
        submiting: false,
        order: order ? order : [],
        member: member ?? false,
        isHamper: isHamper ?? false,
        hamperTermsAndConditions: hamperTermsAndConditions ?? '',
    },
    mounted() {

        $(() => {
            $('#continueCheckout').on('click', () => {
                $('#checkoutPopup').hide();
                this.updateWholeCart(true)
            });
        })

        Object.keys(cartList).forEach((rawId) => {
            // set chocolatePlateActive = true if either a cake plate have value
            if (this.cartList[rawId].chocolate_plate) {
                this.cartList[rawId].vue_shopping_cart.chocolatePlateActive = (
                    this.cartList[rawId].chocolate_plate.cake_plate_1 != "" ||
                    this.cartList[rawId].chocolate_plate.cake_plate_2 != "" ||
                    this.cartList[rawId].chocolate_plate.cake_plate_3 != ""
                )
                this.cartList[rawId].vue_shopping_cart.chocolatePlateShowResult = this.cartList[rawId].vue_shopping_cart.chocolatePlateActive
                this.cartList[rawId].vue_shopping_cart.chocolatePlateLink = Number(this.cartList[rawId].chocolate_plate.cake_plate_1 != "") +
                    Number(this.cartList[rawId].chocolate_plate.cake_plate_2 != "") +
                    Number(this.cartList[rawId].chocolate_plate.cake_plate_3 != "")
                this.chocolateInputLimitCheck(this.cartList[rawId].vue_shopping_cart)
            }
        })
    },
    computed: {
        totalCount() {
            var totalCount = 0;
            Object.keys(this.cartList).forEach((key) => {
                if (!this.cartList[key].free_gift_discount_id) {
                    totalCount += this.cartList[key]["quantity"];
                }
            });
            return totalCount;
        },
        totalPrice() {
            var totalPrice = 0;
            Object.keys(this.cartList).forEach((key) => {
                if (!this.cartList[key].free_gift_discount_id) {
                    totalPrice += this.cartList[key]["item_total_price"];
                    totalPrice += this.cartList[key]["vue_shopping_cart"]["inputTextExtraPrice"] * this.cartList[key]["quantity"];
                    totalPrice += this.cartList[key]["vue_shopping_cart"]["chocolateExtraPrice"] * this.cartList[key]["quantity"];
                    totalPrice += this.cartList[key]["vue_shopping_cart"]["addOnExtraPrice"];
                }
            });
            totalPrice -= this.order.orderLevelDiscount;
            return totalPrice;
        },
    },
    methods: {
        formSetValue(skipBlockTime = false) {
            var setData = {
                lang: this.lang,
                cart: Object.assign({}, this.cartList),
            };

            //isSkipBlockTime
            if (skipBlockTime && skipBlockTime != "false") {
                setData['isSkipBlockTime'] = skipBlockTime;
            }

            //add on handle
            var newCart = {};
            Object.keys(setData.cart).forEach((key) => {

                var tempItem = {
                    product_id: setData.cart[key]["vue_shopping_cart"]["productId"],
                    raw_id: setData.cart[key]["vue_shopping_cart"]["rawId"],
                    attribute: Object.assign({},
                        setData.cart[key]["vue_shopping_cart"]["attributeList"]
                    ),
                };

                //add on handle
                var newAddOn = [];
                tempItem.attribute.add_on.forEach(function (item, index) {
                    if (item["id"] && item["quantity"]) {
                        newAddOn.push({
                            id: item["id"],
                            category_ids: item["category_ids"] ? item["category_ids"] : [],
                            quantity: item["quantity"],
                        });
                    }
                });

                //update
                tempItem.attribute.add_on = newAddOn;

                //update new raw id
                tempItem['raw_id'] = setData.cart[key]["newRawId"];
                var newRawId = setData.cart[key]["newRawId"];

                //update to cart
                if (setData.cart[key]["free_gift_discount_id"] == false) {
                    // newCart[setData.cart[key]["vue_shopping_cart"]["rawId"]] = tempItem;
                    newCart[newRawId] = tempItem;
                }
            });

            //update
            setData.cart = newCart;

            return setData;
        },
        productResponseDataHandle(cartList) {
            var self = this;
            var oldCartKey = [];
            Object.keys(cartList).forEach(function (key) {

                var originalRawId = cartList[key]['original_raw_id'];
                var newRawId = cartList[key]['raw_id'];

                Object.keys(self.cartList).forEach(function (key) {
                    if (key == originalRawId) {
                        self.cartList[key]['raw_id'] = newRawId;
                        self.cartList[key]['newRawId'] = newRawId;
                        self.cartList[key]['vue_shopping_cart']['rawId'] = newRawId;
                        self.cartList[key]['edit_url'] = self.cartList[key]['edit_url'].replace(originalRawId, newRawId);
                        self.cartList[key]['edit_url_admin_panel'] = self.cartList[key]['edit_url_admin_panel'].replace(originalRawId, newRawId);
                        if (key != newRawId) {
                            oldCartKey.push(key);
                            self.cartList[newRawId] = self.cartList[key];
                        }
                    }
                });
            });
            if (oldCartKey != null && oldCartKey.length != 0) {
                Object.keys(oldCartKey).forEach(function (key) {
                    delete self.cartList[oldCartKey[key]];
                });
            }
        },
        async checkOut() {
            if (this.member) {
                await this.updateWholeCart(true);
            }
            // else if(this.isHamper && this.hamperTermsAndConditions){
            //     showAlert('', this.hamperTermsAndConditions, true, '', checkoutPopupShow, '', '', '620px');
            // }
            else {
                $('#checkoutPopup').show();
            }
        },
        async updateWholeCart(runUpdateRemark = false, skipBlockTime = false) {
            var setData = this.formSetValue(skipBlockTime);
            var self = this;
            if (this.submiting) {
                return;
            }
            this.submiting = true;
            var loadingPage = document.getElementsByClassName("loading-wrapper");
            loadingPage[0].className = "loading-wrapper active";
            try {
                $.ajax({
                    url: "/cart/updateWholeCart",
                    type: "POST",
                    dataType: "json",
                    data: setData,
                    success: function (response) {
                        if (response.result == "200") {
                            if (runUpdateRemark) {

                                //GTM
                                self.gtmEventCheckoutData();

                                self.updateRemark();
                            } else {
                                loadingPage[0].className = "loading-wrapper";
                                self.productResponseDataHandle(response.cart);
                                self.order = response.order;
                                self.submiting = false;
                            }
                        } else {
                            self.submiting = false;
                            loadingPage[0].className = "loading-wrapper";
                            if (response.message) {
                                self.showAlert('', response.message);
                            }
                            if (runUpdateRemark) {
                                if (response.url) {
                                    window.location.href = response.url;
                                }

                                if (response.timeout) {
                                    self.delayReload();
                                }
                            }
                        }
                    },
                    error: function (xhr) {
                        self.submiting = false;
                        loadingPage[0].className = "loading-wrapper";
                        var errorMessage = "暫時未能修改";
                        self.showAlert('', errorMessage)
                    },
                });
            } catch (error) {
                self.submiting = false;
                loadingPage[0].className = "loading-wrapper";
                var errorMessage = "遇到錯誤，請再試";
                self.showAlert('', errorMessage);
            }

        },
        async updateWholeCartReturnAllCategory(e) {
            e.preventDefault();
            var returnUrl = $(".btn-back-to-all-category").attr('href');
            var self = this;

            if (this.submiting) {
                return;
            }

            if (this.cartList.length == 0) {
                window.location.href = returnUrl;
                return;
            }

            var setData = this.formSetValue(true);
            this.submiting = true;
            var loadingPage = document.getElementsByClassName("loading-wrapper");
            loadingPage[0].className = "loading-wrapper active";
            try {
                $.ajax({
                    url: "/cart/updateWholeCart",
                    type: "POST",
                    dataType: "json",
                    data: setData,
                    success: function (response) {
                        if (response.result == "200") {
                            window.location.href = returnUrl;
                        } else {
                            self.submiting = false;
                            loadingPage[0].className = "loading-wrapper";
                            if (response.message) {
                                self.showAlert('', response.message);
                            }

                            if (response.url) {
                                window.location.href = response.url;
                            }

                            if (response.timeout) {
                                self.delayReload();
                            }
                        }
                    },
                    error: function (xhr) {
                        self.submiting = false;
                        loadingPage[0].className = "loading-wrapper";
                        var errorMessage = "暫時未能修改";
                        self.showAlert('', errorMessage);
                    },
                });
            } catch (error) {
                self.submiting = false;
                loadingPage[0].className = "loading-wrapper";
                var errorMessage = "遇到錯誤，請再試";
                self.showAlert('', errorMessage);
            }
        },
        async updateRemark() {
            var setData = {
                specialRequest: this.remark
            };
            var self = this;
            try {
                $.ajax({
                    url: "/checkout/updateSpecialRequest",
                    type: "POST",
                    dataType: "json",
                    data: setData,
                    success: function (response) {
                        self.submiting = false;

                        if (response.result == "200") {
                            window.location.href = response.url;
                        } else {
                            self.showAlert('', response.message);
                            if (response.timeout) {
                                self.delayReload();
                            }
                        }
                    },
                    error: function (xhr) {
                        self.submiting = false;
                        var errorMessage = {
                            en: "Update process has something's wrong, please try it later.",
                            tc: "更新過程中有問題，請稍後再試。",
                        };

                        self.showAlert(null, errorMessage[self.lang]);
                    },
                });
            } catch (errorCatch) {
                this.submiting = false;
                var errorMessage = {
                    en: "Running process has something's wrong, please try it later.",
                    tc: "運行過程中有問題，請稍後再試。",
                };
                this.showAlert(null, errorMessage[this.lang]);
            }
        },
        removeHamperItem(cart) {
            showHamperRemoveCartPopup(() => {
                return this.removeItem(cart)
            })

        },
        async removeItem(cart) {
            var loadingPage = document.getElementsByClassName("loading-wrapper");
            loadingPage[0].className = "loading-wrapper active";
            this.submiting = true;
            var rawId = cart["raw_id"];
            var setData = {
                raw_id: rawId
            };
            var self = this;
            try {
                $.ajax({
                    url: "/cart/destroyItemInCart",
                    type: "POST",
                    dataType: "json",
                    data: setData,
                    success: function (response) {

                        if (response.result == "200") {

                            //GTM event update
                            self.gtmEventAddToCartData(cart);

                            location.reload();
                        } else {
                            loadingPage[0].className = "loading-wrapper";
                            self.submiting = false;
                            self.showAlert('', response.message);
                            if (response.timeout) {
                                self.delayReload();
                            }
                        }
                    },
                    error: function (xhr) {
                        loadingPage[0].className = "loading-wrapper";
                        self.submiting = false;
                        var errorMessage = "暫時未能刪除" + xhr;
                        self.showAlert('', errorMessage);
                    },
                });
            } catch (errorCatch) {
                loadingPage[0].className = "loading-wrapper";
                this.submiting = false;
                var errorMessage = "遇到錯誤，請再試";
                this.showAlert('', errorMessage);
            }
        },
        async goCheckoutAndUpdateRemark() {
            let self = this;
            var setData = this.formSetValue();
            try {
                $.ajax({
                    url: "/cart/addItemToCart",
                    type: "POST",
                    dataType: "json",
                    data: setData,
                    success: function (response) {
                        if (response.result == "200") {
                            window.location.href = "http://test.mx-cop.com/en/shoppingCart";
                        } else {
                            self.showAlert('', response.message);
                            if (response.timeout) {
                                self.delayReload();
                            }
                        }
                    },
                    error: function (xhr) {
                        var errorMessage = "暫時未能購買";
                        self.showAlert('', errorMessage);
                    },
                });
            } catch (errorCatch) {
                var errorMessage = "遇到錯誤，請再試";
                self.showAlert('', errorMessage);
            }
        },
        countWords(string, cartRow, isChineseCountOne = false) {
            var count = 0;
            if (!string) {
                return count;
            }

            var characters = string.split("");

            //半形
            characters.forEach(function (item, index) {
                var matches = item.match(/[\u0000-\u00ff]/g);
                if (matches && matches.length) {
                    count++;
                }
            });

            //中文
            characters.forEach(function (item, index) {
                var matches = item.match(/[\u4e00-\u9fa5\u3400-\u4DBF]/g);
                if (matches && matches.length) {
                    if (!cartRow.productData.isHamper) {
                        if (cartRow.containChinese == true && cartRow.containEnglish == true) {
                            count = count + 1.5;
                        } else {
                            count = count + 2;
                        }
                    } else {
                        if (isChineseCountOne) {
                            count = count + 1;
                        } else {
                            count = count + 2;
                        }
                    }
                }
            });

            //全形
            characters.forEach(function (item, index) {
                var matches = item.match(/[\uff00-\uffff]/g);
                if (matches && matches.length) {
                    if (!cartRow.productData.isHamper) {
                        if (cartRow.containChinese == true && cartRow.containEnglish == true) {
                            count = count + 1.5;
                        } else {
                            count = count + 2;
                        }
                    } else {
                        if (isChineseCountOne) {
                            count = count + 1;
                        } else {
                            count = count + 2;
                        }
                    }
                }
            });

            return Math.ceil(count);
        },
        checkWords(string, hamper = false) {
            //emoji
            var regex = /([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g;
            var matches = string.match(regex);
            if (matches && matches.length) {
                var errorMessage = {
                    tc: "不接受表情符號（Emoji）！",
                    en: "Not accept input emoji！",
                };
                this.showAlert('', errorMessage[this.lang]);
            } else {
                if (hamper) {
                    var regex = /[^a-zA-Z0-9\.\,~!@#$%^&*()\s\[\]\{\}\=\-_+\u4E00-\u9FCC\u3400-\u4DBF\uFF00-\uFFEF\u3000-\u303F\u0000-\u007F]+/g;
                } else {
                    var regex = /[^a-zA-Z0-9\.\,~!@#$%^&*()\s\[\]\{\}\=\-_+\u4E00-\u9FCC\u3400-\u4DBF]+/g;
                }
                var matches = string.match(regex);
                if (matches) {
                    var errorMessage = {
                        tc: "不接受除中文字,英文字母,數字及標點符號之外的內容！",
                        en: "Not accept except chinese characters, english letters, numbers and simple symbols!！",
                    };
                    this.showAlert('', errorMessage[this.lang]);
                }
            }
        },
        storeChocolateInputBefore(cartRow) {
            cartRow.chocolateInputLink_1_Before = cartRow.chocolateInputLink_1;
            cartRow.chocolateInputLink_2_Before = cartRow.chocolateInputLink_2;
            cartRow.chocolateInputLink_3_Before = cartRow.chocolateInputLink_3;
        },
        chocolateInputLimitCheck(cartRow, line = null) {
            this.chocolateInputCount(cartRow);
            this.chocolatePlateLinkLimitUpdate(cartRow);
            this.chocolatePlateRemoveChar(cartRow);
            if (line) {
                if (cartRow['chocolateInputLink_' + line + '_Current'] > cartRow['chocolateInputLink_' + line + '_Limit']) {
                    if (line != 2) {
                        if (this.countWords(cartRow['chocolateInputLink_' + line + '_Before'], cartRow, true) <= cartRow['chocolateInputLink_' + line + '_Limit']) {
                            // for chinese and english char mix larger than limit, rollback input action
                            cartRow['chocolateInputLink_' + line] = cartRow['chocolateInputLink_' + line + '_Before'];
                            this.chocolateInputLimitCheck(cartRow, line);
                        }
                    } else {
                        if (this.countWords(cartRow['chocolateInputLink_' + line + '_Before'], cartRow) <= cartRow['chocolateInputLink_' + line + '_Limit']) {
                            // for chinese and english char mix larger than limit, rollback input action
                            cartRow['chocolateInputLink_' + line] = cartRow['chocolateInputLink_' + line + '_Before'];
                            this.chocolateInputLimitCheck(cartRow, line);
                        }
                    }
                }
            }
            var line1Match = (cartRow.chocolateInputLink_1_Limit - cartRow.chocolateInputLink_1_Current) >= 0;
            var line2Match = (cartRow.chocolateInputLink_2_Limit - cartRow.chocolateInputLink_2_Current) >= 0;
            cartRow.canInputChocolatePlateLine3 = line1Match && line2Match;
            if (cartRow.chocolateAdjustLine3) {
                if (cartRow.canInputChocolatePlateLine3) {
                    cartRow.chocolateAdjustLine3 = false;
                }
            }
            this.checkChocolateLimit(cartRow);
            this.$forceUpdate();
        },
        chocolateInputCount(cartRow) {
            cartRow.chocolateInputLink_1_Current = this.countWords(cartRow.chocolateInputLink_1, cartRow, true);
            cartRow.chocolateInputLink_2_Current = this.countWords(cartRow.chocolateInputLink_2, cartRow);
            cartRow.chocolateInputLink_3_Current = this.countWords(cartRow.chocolateInputLink_3, cartRow, true);
            this.checkWords(cartRow.chocolateInputLink_1, cartRow.attributeList.cake_relate.is_hamper);
            this.checkWords(cartRow.chocolateInputLink_2, cartRow.attributeList.cake_relate.is_hamper);
            this.checkWords(cartRow.chocolateInputLink_3, cartRow.attributeList.cake_relate.is_hamper);
        },
        chocolatePlateLinkLimitUpdate(cartRow) {
            // check only chinese/ only english/ mixed
            this.checkChocolatePlateContain(cartRow);
            if (cartRow.productData.isHamper) {
                cartRow.chocolateInputLink_1_Limit = 20;
                cartRow.chocolateInputLink_2_Limit = 100;
                cartRow.chocolateInputLink_3_Limit = 20;
            } else {
                if (cartRow.chocolatePlateLink == 3) {
                    // check current word and limit
                    if (cartRow.chocolateInputLink_1_Current > 12 || cartRow.chocolateInputLink_2_Current > 16) {
                        cartRow.chocolateAdjustLine3 = true;
                    }
                    if (cartRow.containChinese == true && cartRow.containEnglish == true) { // mix
                        cartRow.chocolateInputLink_1_Limit = 9;
                        cartRow.chocolateInputLink_2_Limit = 12;
                        cartRow.chocolateInputLink_3_Limit = 9;
                    } else if (cartRow.containChinese == true && cartRow.containEnglish == false) { // chinese only
                        cartRow.chocolateInputLink_1_Limit = 12;
                        cartRow.chocolateInputLink_2_Limit = 16;
                        cartRow.chocolateInputLink_3_Limit = 12;
                    } else { // english only
                        cartRow.chocolateInputLink_1_Limit = 10;
                        cartRow.chocolateInputLink_2_Limit = 15;
                        cartRow.chocolateInputLink_3_Limit = 10;
                    }
                } else {
                    if (cartRow.containChinese == true && cartRow.containEnglish == true) { // mix
                        cartRow.chocolateInputLink_1_Limit = 12;
                        cartRow.chocolateInputLink_2_Limit = 12;
                        cartRow.chocolateInputLink_3_Limit = 8;
                    } else if (cartRow.containChinese == true && cartRow.containEnglish == false) { // chinese only
                        cartRow.chocolateInputLink_1_Limit = 16;
                        cartRow.chocolateInputLink_2_Limit = 16;
                        cartRow.chocolateInputLink_3_Limit = 8;
                    } else { // english only
                        cartRow.chocolateInputLink_1_Limit = 15;
                        cartRow.chocolateInputLink_2_Limit = 15;
                        cartRow.chocolateInputLink_3_Limit = 8;
                    }
                }
            }
        },
        checkChocolatePlateContain(cartRow) {
            cartRow.containEnglish = false;
            cartRow.containChinese = false;
            var line1 = cartRow.chocolateInputLink_1;
            var line2 = cartRow.chocolateInputLink_2;
            var line3 = cartRow.chocolateInputLink_3;
            if (line1 != '') {
                var line1Split = line1.split("");
                //半形
                line1Split.forEach(function (item, index) {
                    var matchEnglish = item.match(/[\u0000-\u00ff]/g);
                    if (matchEnglish && matchEnglish.length) {
                        cartRow.containEnglish = true;
                    }
                    var matchChinese = item.match(/[\u4e00-\u9fa5\u3400-\u4DBF]/g);
                    var matchFullSize = item.match(/[\uff00-\uffff]/g);
                    if (matchChinese && matchChinese.length || matchFullSize && matchFullSize.length) {
                        cartRow.containChinese = true;
                    }
                });
            }
            if (line2 != '') {
                var line2Split = line2.split("");
                //半形
                line2Split.forEach(function (item, index) {
                    var matchEnglish = item.match(/[\u0000-\u00ff]/g);
                    if (matchEnglish && matchEnglish.length) {
                        cartRow.containEnglish = true;
                    }
                    var matchChinese = item.match(/[\u4e00-\u9fa5\u3400-\u4DBF]/g);
                    var matchFullSize = item.match(/[\uff00-\uffff]/g);
                    if (matchChinese && matchChinese.length || matchFullSize && matchFullSize.length) {
                        cartRow.containChinese = true;
                    }
                });
            }
            if (line3 != '') {
                var line3Split = line3.split("");
                //半形
                line3Split.forEach(function (item, index) {
                    var matchEnglish = item.match(/[\u0000-\u00ff]/g);
                    if (matchEnglish && matchEnglish.length) {
                        cartRow.containEnglish = true;
                    }
                    var matchChinese = item.match(/[\u4e00-\u9fa5\u3400-\u4DBF]/g);
                    var matchFullSize = item.match(/[\uff00-\uffff]/g);
                    if (matchChinese && matchChinese.length || matchFullSize && matchFullSize.length) {
                        cartRow.containChinese = true;
                    }
                });
            }
        },
        chocolatePlateRemoveChar(cartRow) {
            //default check
            // cartRow.chocolateInputLink_1 = cartRow.chocolateInputLink_1.slice(0, cartRow.chocolateInputLink_1_Limit);
            // cartRow.chocolateInputLink_2 = cartRow.chocolateInputLink_2.slice(0, cartRow.chocolateInputLink_2_Limit);
            // cartRow.chocolateInputLink_3 = cartRow.chocolateInputLink_3.slice(0, cartRow.chocolateInputLink_3_Limit);

            //remove emoji
            var regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;
            cartRow.chocolateInputLink_1 = cartRow.chocolateInputLink_1.replace(regex, "");
            cartRow.chocolateInputLink_2 = cartRow.chocolateInputLink_2.replace(regex, "");
            cartRow.chocolateInputLink_3 = cartRow.chocolateInputLink_3.replace(regex, "");

            //remove other char
            if (cartRow.attributeList.cake_relate.is_hamper) {
                var regex = /[^a-zA-Z0-9\.\,~!@#$%^&*()\s\[\]\{\}\=\-_+\u4E00-\u9FCC\u3400-\u4DBF\uFF00-\uFFEF\u3000-\u303F\u0000-\u007F]+/g;
            } else {
                var regex = /[^a-zA-Z0-9\.\,~!@#$%^&*()\s\[\]\{\}\=\-_+\u4E00-\u9FCC\u3400-\u4DBF]+/g;
            }
            cartRow.chocolateInputLink_1 = cartRow.chocolateInputLink_1.replace(regex, "");
            cartRow.chocolateInputLink_2 = cartRow.chocolateInputLink_2.replace(regex, "");
            cartRow.chocolateInputLink_3 = cartRow.chocolateInputLink_3.replace(regex, "");

            this.chocolateInputCount(cartRow);

            //checka again
            for (var i = 1; i < cartRow.chocolateInputLink_1_Current; i++) {
                if (cartRow.chocolateInputLink_1_Current > cartRow.chocolateInputLink_1_Limit) {
                    var tempLimit = cartRow.chocolateInputLink_1_Limit;
                    // cartRow.chocolateInputLink_1 = cartRow.chocolateInputLink_1.slice(0, tempLimit - i);
                    cartRow.chocolateInputLink_1_Current = this.countWords(cartRow.chocolateInputLink_1, cartRow, true);
                }
            }

            for (var i = 1; i < cartRow.chocolateInputLink_2_Current; i++) {
                if (cartRow.chocolateInputLink_2_Current > cartRow.chocolateInputLink_2_Limit) {
                    var tempLimit = cartRow.chocolateInputLink_2_Limit;
                    // cartRow.chocolateInputLink_2 = cartRow.chocolateInputLink_2.slice(0, tempLimit - i);
                    cartRow.chocolateInputLink_2_Current = this.countWords(cartRow.chocolateInputLink_2, cartRow);
                }
            }

            for (var i = 1; i < cartRow.chocolateInputLink_3_Current; i++) {
                if (cartRow.chocolateInputLink_3_Current > cartRow.chocolateInputLink_3_Limit) {
                    var tempLimit = cartRow.chocolateInputLink_3_Limit;
                    // cartRow.chocolateInputLink_3 = cartRow.chocolateInputLink_3.slice(0, tempLimit - i);
                    cartRow.chocolateInputLink_3_Current = this.countWords(cartRow.chocolateInputLink_3, cartRow, true);
                }
            }

            this.chocolateInputCount(cartRow);
        },
        chocolatePlateAddLine(cartRow, number) {
            cartRow.chocolatePlateActive = true;
            cartRow.chocolatePlateLink = number;
            if (cartRow.productData.isHamper) {
                cartRow.chocolatePlateLink = 3;
            }
            this.chocolateInputLimitCheck(cartRow);
            this.calucalateChocolateExtraPrice(cartRow);
        },
        chocolatePlateLineDelete(cartRow, index) {
            if (this.isHamper) {
                if (index == 3) {
                    cartRow.chocolateInputLink_3 = "";
                }
                if (index == 2) {
                    cartRow.chocolateInputLink_2 = "";
                }
                if (index == 1) {
                    cartRow.chocolateInputLink_1 = "";
                }
            } else {
                if (index == 3) {
                    cartRow.chocolateInputLink_3 = "";
                    cartRow.chocolatePlateLink = 2;
                }
                if (index == 2) {
                    if (cartRow.chocolatePlateLink == 3) {
                        cartRow.chocolateInputLink_2 = cartRow.chocolateInputLink_3;
                        cartRow.chocolateInputLink_3 = "";
                        cartRow.chocolatePlateLink = 2;
                    } else if (cartRow.chocolatePlateLink == 2) {
                        cartRow.chocolateInputLink_2 = "";
                        cartRow.chocolatePlateLink = 1;
                    }
                }

                if (index == 1) {
                    if (cartRow.chocolatePlateLink >= 2) {
                        cartRow.chocolateInputLink_1 = cartRow.chocolateInputLink_2;
                        cartRow.chocolateInputLink_2 = cartRow.chocolateInputLink_3;
                        cartRow.chocolateInputLink_3 = "";
                        cartRow.chocolatePlateLink--;
                    } else if (cartRow.chocolatePlateLink == 1) {
                        cartRow.chocolateInputLink_1 = "";
                        cartRow.chocolatePlateLink = 0;
                        cartRow.chocolatePlateActive = false;
                        cartRow.attributeList.chocolate_plate.cake_plate_1 = "";
                        cartRow.attributeList.chocolate_plate.cake_plate_2 = "";
                        cartRow.attributeList.chocolate_plate.cake_plate_3 = "";
                        this.updateWholeCart(false, true);
                    }
                }
            }
            this.chocolateInputLimitCheck(cartRow);
            this.calucalateChocolateExtraPrice(cartRow);
        },
        chocolatePlateContentChecking(cartRow) {
            this.chocolateInputLimitCheck(cartRow);
            if (cartRow.chocolatePlateLinkErrorShow) {
                return false;
            }
            this.checkChocolateLimit(cartRow);
            if (cartRow.chocolateLine1Alert || cartRow.chocolateLine2Alert || cartRow.chocolateLine3Alert) {
                return false;
            }

            return true;
        },
        checkChocolateLimit(cartRow) {
            if (cartRow.chocolateInputLink_1_Current > cartRow.chocolateInputLink_1_Limit) {
                cartRow.chocolateLine1Alert = true;
            } else {
                cartRow.chocolateLine1Alert = false;
            }
            if (cartRow.chocolateInputLink_2_Current > cartRow.chocolateInputLink_2_Limit) {
                cartRow.chocolateLine2Alert = true;
            } else {
                cartRow.chocolateLine2Alert = false;
            }
            if (cartRow.chocolateInputLink_3_Current > cartRow.chocolateInputLink_3_Limit) {
                cartRow.chocolateLine3Alert = true;
            } else {
                cartRow.chocolateLine3Alert = false;
            }
        },
        chocolatePlateSave(cartRow) {
            var result = this.chocolatePlateContentChecking(cartRow);
            if (!result) {
                return;
            }

            cartRow.attributeList.chocolate_plate.cake_plate_1 =
                cartRow.chocolateInputLink_1;
            cartRow.attributeList.chocolate_plate.cake_plate_2 =
                cartRow.chocolateInputLink_2;
            cartRow.attributeList.chocolate_plate.cake_plate_3 =
                cartRow.chocolateInputLink_3;

            if (cartRow.attributeList.chocolate_plate.cake_plate_1 == '' && cartRow.attributeList.chocolate_plate.cake_plate_2 == '' && cartRow.attributeList.chocolate_plate.cake_plate_3 == '') {
                cartRow.chocolatePlateActive = false;
                cartRow.chocolatePlateShowResult = false;
            } else {
                cartRow.chocolatePlateShowResult = true;
            }
            this.updateWholeCart(false, true);
        },
        closeChocolatePlatePopup(cartRow) {
            if (cartRow.attributeList.chocolate_plate.cake_plate_1 == '' && cartRow.attributeList.chocolate_plate.cake_plate_2 == '' && cartRow.attributeList.chocolate_plate.cake_plate_3 == '') {
                cartRow.chocolatePlateActive = false;
                cartRow.chocolateInputLink_1 = '';
                cartRow.chocolateInputLink_2 = '';
                cartRow.chocolateInputLink_3 = '';
            } else {
                cartRow.chocolatePlateShowResult = true;
            }
        },
        calucalateAddOnPrice(cart) {
            var price = 0;
            cart.attributeList.add_on.forEach(function (item, index) {
                if (isInt(parseInt(cart.attributeList.add_on[index]["quantity"]))) {
                    if (parseInt(cart.attributeList.add_on[index]["quantity"]) <= 0) {
                        cart.attributeList.add_on[index]["quantity"] = 1;
                    }
                    cart.attributeList.add_on[index]["quantity"] = parseInt(cart.attributeList.add_on[index]["quantity"]);
                } else {
                    cart.attributeList.add_on[index]["quantity"] = 1;
                }
                if (cart.attributeList.add_on[index]["quantity"] <= 0) {
                    cart.attributeList.add_on[index]["quantity"] = 1;
                }

                var tempId = item["id"];
                var tempQuantity = item["quantity"];
                var tempDisplay = item["display"];
                if (tempId && tempQuantity && tempDisplay && tempQuantity > 0) {
                    let addOnOption = cart.productData.addOnOptions.find(
                        (o) => o.id == tempId
                    );
                    price += addOnOption["price"] * tempQuantity;
                }
            });
            cart.addOnExtraPrice = price;
            this.updateWholeCart(false, true);
        },
        calucalateChocolateExtraPrice(cart) {
            var price = 0;
            if (
                cart.chocolatePlateActive &&
                cart.cakeWithCrustFlavorPrice <
                cart.productData.minFreeChocolatePlatePrice &&
                !cart.productData.isHamper
            ) {
                price = cart.productData.chocolatePlatePrice;
            }
            cart.chocolateExtraPrice = price;
        },
        addOnSelectItemClick(cart, id, index, addOnItem) {
            addOnItem.id = id;
            addOnItem.index = index;
            addOnItem.listShow = false;
            this.calucalateAddOnPrice(cart);
        },
        addNewAddOnItem(cart) {
            cart.attributeList.add_on.push({
                id: "",
                quantity: 1,
                listShow: false,
                index: "",
                display: true,
            });
        },
        deleteAddOn(cart, index) {
            cart.attributeList.add_on.splice(index, 1);
            this.calucalateAddOnPrice(cart);
        },

        //GTM function
        gtmEventAddToCartData(cart) {
            var productList = [];

            //product
            var product = {
                'id': cart.vue_shopping_cart.productData.product.pos_code,
                'name': cart.name_tc,
                'revenue': cart.vue_shopping_cart.productData.isFixedWeight ? cart.vue_shopping_cart.productData.weight : cart.attribute_list.cake_relate.weight,
                'price': cart.cake_with_crust_flavor_price,
                'quanatity': cart.attribute_list.cake_relate.quantity,
            };
            productList.push(product);

            this.productDetailAddToCartDataHandle(productList);
        },
        productDetailAddToCartDataHandle(productList) {


            var eventName = 'productAddToCart';
            var ecommerce = {
                remove: {
                    products: productList
                }
            };

            //push
            this.pushToDataLayer(eventName, ecommerce);
        },
        gtmEventCheckoutData() {
            var productList = [];

            Object.keys(this.cartList).forEach((key) => {

                //product
                var product = {
                    'id': this.cartList[key].vue_shopping_cart.productData.product.pos_code,
                    'name': this.cartList[key].name_tc,
                    'revenue': this.cartList[key].vue_shopping_cart.productData.isFixedWeight ? this.cartList[key].vue_shopping_cart.productData.weight : this.cartList[key].attribute_list.cake_relate.weight,
                    'price': this.cartList[key].cake_with_crust_flavor_price,
                    'quanatity': this.cartList[key].attribute_list.cake_relate.quantity,
                };
                productList.push(product);

            });

            this.gtmCheckoutDataHandle(productList);
        },
        gtmCheckoutDataHandle(productList) {
            var eventName = 'checkout';
            var ecommerce = {
                checkout: {
                    actionField: {
                        step: 1
                    },
                    products: productList
                }
            };

            //push
            this.pushToDataLayer(eventName, ecommerce);
        },

        setAttributeList(rawId, row, column, value) {
            Vue.set(this.cartList[rawId].vue_shopping_cart.attributeList.cake_cover_input_char[row], column, value);

            var price = 0;
            if (this.cartList[rawId].vue_shopping_cart.productData.coverInputExtraCalculate) {
                if (this.cartList[rawId].vue_shopping_cart.attributeList.cake_cover_input_char[0][0] !== '' && this.cartList[rawId].vue_shopping_cart.attributeList.cake_cover_input_char[0][1] !== '') {
                    price = this.cartList[rawId].vue_shopping_cart.productData.coverInputExtraPrice;
                }
            }
            Vue.set(this.cartList[rawId]["vue_shopping_cart"], 'inputTextExtraPrice', price);
        },
    },
    watch: {},
});
//------------------------------------------------
$(function () {
    //product Detail
    //------------------------------------------------------------------
    function initSelectOrDie() {
        $(".detail-content")
            .find(".select-order")
            .unbind()
            .selectOrDie({
                onChange: function () {
                    var value = $(this).val();
                    var field = $(this).attr("data-field");
                    var className = $(this).attr("data-main-name");

                    if (field == "input_char") {
                        var row = $(this).attr("data-row-index");
                        var column = $(this).attr("data-column-index");
                        selectUpdateToVueStringChar(row, column, value);
                        $(this).selectOrDie("update");
                        $(
                            "." +
                            className +
                            "[data-row-index=" +
                            row +
                            "][data-column-index=" +
                            column +
                            "]"
                        ).selectOrDie("update");
                    } else if (field) {
                        selectUpdateToVue(field, value);
                        $(this).selectOrDie("update");
                        $("." + className).selectOrDie("update");
                    }
                },
            });
    }
    initSelectOrDie();
    //------------------------------------------------------------------
    //vue update
    function selectUpdateToVue(inputField, inputValue) {
        var vueProductDetailData =
            productDetailVue.$data.attributeList;

        $.each(vueProductDetailData, function (subKey, subList) {
            if (
                typeof subList === "object" &&
                subList !== null &&
                subKey != "add_on"
            ) {
                $.each(subList, function (key, value) {
                    if (key == inputField) {
                        productDetailVue.$data.attributeList[subKey][
                            key
                        ] = inputValue;
                    }
                });
            }
            if (subKey == inputField) {
                productDetailVue.$data.attributeList[subKey] = inputValue;
            }
        });
    }

    function selectUpdateToVueStringChar(row, column, value) {
        if (row && column) {

            productDetailVue.$data.attributeList.cake_cover_input_char[
                row
            ][column] = value;

        }
    }
    //------------------------------------------------------------------
    //mobile function
    $("#mobile-purchase-close").click(function (e) {
        e.preventDefault();
        $("#mobile-cart").fadeIn();
        $("#mobile-purchase-options").fadeOut();
        var $docEl = $("html, body");
        $docEl.css({
            height: "100%",
            overflow: "",
        });

        updateSelectOrDie();
    });
    $("#mobile-purchase-open, .show-mobile-cart").click(function (e) {
        e.preventDefault();
        $("#mobile-purchase-options").fadeIn();
        $("#mobile-cart").fadeOut();

        calculateMobileOptionSize();

        var $docEl = $("html, body");
        $docEl.css({
            height: "100%",
            overflow: "hidden",
        });

        updateSelectOrDie();
    });

    function updateSelectOrDie() {
        $(".select-order").each(function (index, value) {
            if ($(value).val()) {
                $(value).selectOrDie("update");
            }
        });
    }

    function calculateMobileOptionSize() {
        var winH = $(window).height();
        var topH = $(
            "#mobile-purchase-options .top-container"
        ).height();
        var totalH = $(
            "#mobile-purchase-options .total-container"
        ).height();
        $("#mobile-purchase-options .cake-list")
            .css("height", winH - topH - totalH)
            .css("top", topH);
    }

    //---------------------------------------------------------
    //---------------------------------------------------------
    //shoping cart
    function initSelectOrDieShoppingCart() {
        $(".shopping-cart-main-area")
            .find(".select-order")
            .unbind()
            .selectOrDie({
                onChange: function () {

                    var value = $(this).val();
                    var field = $(this).attr("data-field");
                    var className = $(this).attr("data-main-name");
                    var rawId = $(this).attr('data-raw-id');

                    if (field == "input_char") {
                        var row = $(this).attr("data-row-index");
                        var column = $(this).attr("data-column-index");
                        selectUpdateToVueStringCharShoppingCart(row, column, value, rawId);
                        $(this).selectOrDie("update");
                        $("." + className + "[data-row-index=" + row + "][data-column-index=" + column + "]")
                            .selectOrDie("update");
                    } else if (field) {
                        selectUpdateToVueShoppingCart(field, value, rawId);
                        $(this).selectOrDie("update");
                        $("." + className).selectOrDie("update");
                    }
                },
            });
    }
    initSelectOrDieShoppingCart();
    //------------------------------------------------------------------
    //vue update
    function selectUpdateToVueShoppingCart(inputField, inputValue, rawId) {
        var vueProductDetailData =
            cartDetailVue.$data.cartList[rawId].vue_shopping_cart.attributeList;

        $.each(vueProductDetailData, function (subKey, subList) {
            if (
                typeof subList === "object" &&
                subList !== null &&
                subKey != "add_on"
            ) {
                $.each(subList, function (key, value) {
                    if (key == inputField) {
                        cartDetailVue.$data.cartList[rawId].vue_shopping_cart.attributeList[subKey][key] = inputValue;
                    }
                });
            }
            if (subKey == inputField) {
                cartDetailVue.$data.cartList[rawId].vue_shopping_cart.attributeList[subKey] = inputValue;
            }
        });
    }

    function selectUpdateToVueStringCharShoppingCart(row, column, value, rawId) {
        if (row && column) {
            cartDetailVue.setAttributeList(rawId, row, column, value);
        }
    }

});